import React from "react";
import { NextUIProvider } from "@nextui-org/react";

/**
 * Wrapper for NextUIProvider that handles chunk loading errors gracefully
 * This helps prevent the app from breaking when NextUI components fail to load
 */
class NextUIProviderWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasNextUIError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if this is a NextUI-related chunk loading error
    if (
      error.name === "ChunkLoadError" ||
      (error.message && error.message.includes("nextui-org"))
    ) {
      return { hasNextUIError: true };
    }
    return null;
  }

  componentDidCatch(error, errorInfo) {
    if (
      error.name === "ChunkLoadError" ||
      (error.message && error.message.includes("nextui-org"))
    ) {
      console.error("NextUI chunk loading error:", error);
      console.error("Error info:", errorInfo);
    }
  }

  render() {
    if (this.state.hasNextUIError) {
      // Fallback: render children without NextUIProvider
      // This allows the app to continue functioning even if NextUI fails
      console.warn("NextUI failed to load, rendering without NextUI provider");
      return <main className="light">{this.props.children}</main>;
    }

    try {
      return (
        <NextUIProvider>
          <main className="light">{this.props.children}</main>
        </NextUIProvider>
      );
    } catch (error) {
      console.error("NextUIProvider error:", error);
      // Fallback to rendering without NextUI
      return <main className="light">{this.props.children}</main>;
    }
  }
}

export default NextUIProviderWrapper;
